import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "min-h-screen bg-gray-lightShow flex justify-center items-center text-green-lightShow text-lg font-bold"
}
const _hoisted_2 = {
  key: 1,
  class: "min-h-screen bg-gray-lightShow"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "space-y-4 p-4" }
const _hoisted_5 = { class: "space-y-2 text-left" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "grow text-base font-medium" }
const _hoisted_8 = { class: "text-xl font-medium" }
const _hoisted_9 = {
  key: 0,
  class: "text-xl font-medium"
}
const _hoisted_10 = { class: "space-x-2 text-base font-medium" }
const _hoisted_11 = {
  key: 0,
  class: "text-gray-400 line-through"
}
const _hoisted_12 = {
  key: 1,
  class: "text-green-lightShow"
}
const _hoisted_13 = { class: "text-sm font-medium text-green-lightShow" }
const _hoisted_14 = { class: "text-base" }
const _hoisted_15 = { class: "whitespace-pre-wrap" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "border-b-2 border-black text-left py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-medium" }, "ご利用方法")
], -1)
const _hoisted_17 = { class: "py-4 text-left" }
const _hoisted_18 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_19 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_20 = { class: "whitespace-pre-wrap" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "border-b-2 border-black text-left py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-medium" }, "決済について")
], -1)
const _hoisted_22 = { class: "py-4 text-left" }
const _hoisted_23 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_24 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "border-b-2 border-black text-left py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-medium" }, "ご利用条件")
], -1)
const _hoisted_28 = { class: "py-4 text-left" }
const _hoisted_29 = { class: "text-sm whitespace-pre-wrap" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "border-b-2 border-black text-left py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-medium" }, "商品詳細")
], -1)
const _hoisted_31 = { class: "py-4 text-left" }
const _hoisted_32 = { class: "text-sm whitespace-pre-wrap" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "border-b-2 border-black text-left py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-medium" }, "関連リンク集")
], -1)
const _hoisted_35 = { class: "py-4 text-left" }
const _hoisted_36 = { class: "text-sm whitespace-pre-wrap break-all" }
const _hoisted_37 = ["href"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "border-b-2 border-black text-left py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-medium" }, "商品のスペック")
], -1)
const _hoisted_39 = { class: "py-4 text-left" }
const _hoisted_40 = { class: "text-sm whitespace-pre-wrap" }
const _hoisted_41 = { class: "flex space-x-4 text-left" }
const _hoisted_42 = ["src", "alt"]
const _hoisted_43 = { class: "table" }
const _hoisted_44 = { class: "font-bold text-base align-middle table-cell" }
const _hoisted_45 = { class: "sticky bottom-0 px-4 pb-6 pt-2 bg-gray-lightShow shadow" }
const _hoisted_46 = {
  key: 1,
  type: "submit",
  class: "text-center block w-full items-center rounded-md border border-transparent bg-green-show px-6 py-2 text-base font-medium text-white shadow-sm opacity-50"
}
const _hoisted_47 = {
  key: 2,
  type: "submit",
  class: "text-center block w-full items-center rounded-md border border-transparent bg-green-show px-6 py-2 text-base font-medium text-white shadow-sm opacity-50"
}
const _hoisted_48 = { class: "relative max-w-md mx-auto bg-gray-lightShow rounded-md" }
const _hoisted_49 = { class: "space-y-4" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xl text-black font-bold text-left" }, " 特別優待を利用する ")
], -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-left" }, [
    /*#__PURE__*/_createTextVNode(" この特別優待を利用するには、「コンシェルジュに予約を依頼」ボタンからコンシェルジュに予約を依頼してください。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" ボタンを押すと、自動的に特別優待コードが送信されます。 ")
  ])
], -1)
const _hoisted_52 = { class: "text-left" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs" }, "ショップ名", -1)
const _hoisted_54 = { class: "text-base font-bold" }
const _hoisted_55 = { class: "text-left" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs" }, "商品名", -1)
const _hoisted_57 = { class: "text-base font-bold" }
const _hoisted_58 = {
  key: 0,
  class: "text-left"
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs" }, "金額", -1)
const _hoisted_60 = { class: "text-base font-bold" }
const _hoisted_61 = {
  key: 1,
  class: "text-left"
}
const _hoisted_62 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs" }, "割引", -1)
const _hoisted_63 = {
  key: 0,
  class: "text-base font-bold"
}
const _hoisted_64 = {
  key: 1,
  class: "text-base font-bold"
}
const _hoisted_65 = {
  key: 2,
  class: "text-base font-bold"
}
const _hoisted_66 = { class: "text-left" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs" }, "特別優待コード", -1)
const _hoisted_68 = { class: "text-base font-bold" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("p", { class: "text-white font-bold text-sm text-center" }, " コンシェルジュに予約を依頼 ", -1)
const _hoisted_70 = [
  _hoisted_69
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_HeartIcon = _resolveComponent("HeartIcon")!
  const _component_ChevronRightIcon = _resolveComponent("ChevronRightIcon")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (!_ctx.voucher)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, " ご利用できる優待がありません "))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_component_van_swipe, {
          "show-indicators": true,
          "indicator-color": "#374C4E"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.voucher.images, (voucherImage) => {
              return (_openBlock(), _createBlock(_component_van_swipe_item, {
                key: voucherImage.voucherImageId
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("img", {
                      src: voucherImage.imageUrl,
                      alt: "",
                      class: "aspect-square w-full object-cover"
                    }, null, 8, _hoisted_3)
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.voucher.shop.name), 1),
              _createVNode(_component_HeartIcon, {
                class: _normalizeClass(["h-6 w-6", _ctx.voucher.favorite ? 'text-red-show' : 'opacity-20']),
                onClick: _ctx.addFavorite
              }, null, 8, ["class", "onClick"])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.voucher.name), 1)
            ]),
            _createElementVNode("div", null, [
              (!!_ctx.voucher.discountedPrice || _ctx.voucher.discountedPrice === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, " ￥" + _toDisplayString(_ctx.voucher.discountedPrice.toLocaleString()), 1))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_10, [
                (_ctx.voucher.price != 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, " ￥" + _toDisplayString(_ctx.voucher.price.toLocaleString()), 1))
                  : _createCommentVNode("", true),
                (
                _ctx.voucher.discountType === _ctx.DiscountTypes.Amount ||
                _ctx.voucher.discountType === _ctx.DiscountTypes.Rate
              )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.voucher.discountValue.toLocaleString()) + " " + _toDisplayString(_ctx.SuffixDiscountValueLabels[_ctx.voucher.discountType]), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.voucher.summary), 1),
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.expireDate()), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              (_ctx.voucher.voucherType == _ctx.VoucherTypes.Experience)
                ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.ExperienceUsageLabels), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.ProductUsageLabels), 1))
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              (_ctx.voucher.voucherType == _ctx.VoucherTypes.Experience)
                ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_ctx.ExperiencePaymentLabels[_ctx.voucher.paymentMethod]), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_24, [
                    (_ctx.voucher.hasTemporarilyReservation)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.ProductPaymentLabels[2]), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.ProductPaymentLabels[1]), 1))
                  ]))
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.voucher.conditionOfUse), 1)
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.voucher.description), 1)
            ])
          ]),
          (_ctx.voucher.relatedUrl != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("p", _hoisted_36, [
                    _createElementVNode("a", {
                      href: _ctx.voucher.relatedUrl,
                      class: "underline text-sky-400 hover:text-sky-800 visited:text-purple-600"
                    }, _toDisplayString(_ctx.voucher.relatedUrl), 9, _hoisted_37)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _hoisted_38,
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.voucher.spec), 1)
            ])
          ]),
          _createElementVNode("div", {
            class: "bg-white text-left p-1 flex justify-between",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goShopPage(_ctx.voucher.shop.id)))
          }, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("img", {
                src: _ctx.voucher.shop.imageUrl,
                alt: _ctx.voucher.shop.name,
                height: 50,
                width: 50,
                class: "aspect-square object-cover"
              }, null, 8, _hoisted_42),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.voucher.shop.name), 1)
              ])
            ]),
            _createVNode(_component_ChevronRightIcon, { class: "color-black h-5 w-5 my-auto" })
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", null, [
            (_ctx.hasValidReserve)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "submit",
                  class: "text-center block w-full items-center rounded-md border border-transparent bg-green-show px-6 py-2 text-base font-medium text-white shadow-sm",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goReserve && _ctx.goReserve(...args)))
                }, " 予約詳細 "))
              : (_ctx.isReachedLimit)
                ? (_openBlock(), _createElementBlock("button", _hoisted_46, " 予約回数が上限に達しました。 "))
                : (_ctx.isDisableSubmit)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_47, " この優待を利用する "))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 3,
                      type: "submit",
                      class: "text-center block w-full items-center rounded-md border border-transparent bg-green-show px-6 py-2 text-base font-medium text-white shadow-sm",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setIsOpen(true)))
                    }, " この優待を利用する "))
          ])
        ]),
        _createVNode(_component_van_popup, {
          show: _ctx.isOpen,
          "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isOpen) = $event)),
          closeable: true,
          round: true,
          position: "bottom",
          style: {height: '80%'},
          class: "bg-gray-lightShow py-12 px-4"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _hoisted_50,
                _hoisted_51,
                _createElementVNode("div", _hoisted_52, [
                  _hoisted_53,
                  _createElementVNode("p", _hoisted_54, _toDisplayString(_ctx.voucher.shop.name), 1)
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _hoisted_56,
                  _createElementVNode("p", _hoisted_57, _toDisplayString(_ctx.voucher.name), 1)
                ]),
                (!!_ctx.voucher.discountedPrice || _ctx.voucher.discountedPrice === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                      _hoisted_59,
                      _createElementVNode("p", _hoisted_60, " ￥" + _toDisplayString(_ctx.voucher.discountedPrice.toLocaleString()), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_61, [
                      _hoisted_62,
                      (_ctx.voucher.discountType === _ctx.DiscountTypes.Free)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_63, " 100% OFF "))
                        : (
                _ctx.voucher.discountType === _ctx.DiscountTypes.Amount ||
                _ctx.voucher.discountType === _ctx.DiscountTypes.Rate
              )
                          ? (_openBlock(), _createElementBlock("p", _hoisted_64, _toDisplayString(_ctx.voucher.discountValue.toLocaleString()) + " " + _toDisplayString(_ctx.SuffixDiscountValueLabels[_ctx.voucher.discountType]), 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_65, _toDisplayString(_ctx.voucher.summary), 1))
                    ])),
                _createElementVNode("div", _hoisted_66, [
                  _hoisted_67,
                  _createElementVNode("p", _hoisted_68, _toDisplayString(_ctx.voucher.voucherCode), 1)
                ]),
                _createElementVNode("div", {
                  class: "bg-green-show py-3 rounded-md",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSubmit()))
                }, _hoisted_70)
              ])
            ])
          ]),
          _: 1
        }, 8, ["show"])
      ]))
}